// import { useState, useEffect } from "react";
// import { cn } from "lib/utils";
import { FileText, AlertCircle } from "lucide-react";

import { useEffect, useRef } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import { zoomPlugin } from "@react-pdf-viewer/zoom";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

function DocumentLoader() {
  return (
    <div className="flex flex-col items-center justify-center gap-6 py-20">
      <div className="relative">
        <div className="absolute inset-0 size-20 animate-ping rounded-full bg-primary/20" />
        <div className="absolute inset-2 size-16 animate-pulse rounded-full bg-primary/30" />
        <div className="relative size-20">
          <svg className="size-20 animate-spin" viewBox="0 0 80 80">
            <circle className="stroke-muted" cx="40" cy="40" r="32" fill="none" strokeWidth="4" />
            <circle
              className="stroke-primary"
              cx="40"
              cy="40"
              r="32"
              fill="none"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="200"
              strokeDashoffset="150"
            />
          </svg>
          <FileText className="absolute left-1/2 top-1/2 size-8 -translate-x-1/2 -translate-y-1/2 text-primary" />
        </div>
      </div>
      <div className="flex flex-col items-center gap-2">
        <p className="text-lg font-medium text-foreground">Loading Document</p>
        <p className="text-sm text-muted-foreground">Please wait while we fetch your document...</p>
      </div>
      <div className="flex gap-1.5">
        <div className="size-2 animate-bounce rounded-full bg-primary [animation-delay:-0.3s]" />
        <div className="size-2 animate-bounce rounded-full bg-primary [animation-delay:-0.15s]" />
        <div className="size-2 animate-bounce rounded-full bg-primary" />
      </div>
    </div>
  );
}

export function PDFViewer({ key, file, currentPage, scale, isLoading, onLoadSuccess, onLoadError }) {
  const hasJumpedRef = useRef(false);

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    renderToolbar: () => <></>,
  });
  // const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const pageNavigationPluginInstance = pageNavigationPlugin();
  const { jumpToPage } = pageNavigationPluginInstance;

  const zoomPluginInstance = zoomPlugin();
  const { zoomTo } = zoomPluginInstance;

  useEffect(() => {
    console.log("currentPage: ", currentPage);
    if (currentPage > 0 && hasJumpedRef.current) {
      setTimeout(() => {
        jumpToPage(currentPage - 1);
      }, 500);
    }
  }, [currentPage]);

  useEffect(() => {
    hasJumpedRef.current = false;
  }, [file]);

  useEffect(() => {
    console.log("scale: ", scale);

    zoomTo(scale);
  }, [scale]);

  if (!file || isLoading) {
    return <DocumentLoader />;
  }

  return (
    <div key={key} className="w-full h-[50vh] overflow-hidden rounded-md border">
      <Worker workerUrl="/pdf.worker.min.js">
        {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js"> */}
        <Viewer
          key={key}
          fileUrl={file}
          plugins={[defaultLayoutPluginInstance, pageNavigationPluginInstance, zoomPluginInstance]}
          onDocumentLoad={(e) => {
            onLoadSuccess?.({ numPages: e.doc.numPages });
            if (!hasJumpedRef.current && currentPage > 0) {
              setTimeout(() => {
                jumpToPage(currentPage - 1);
              }, 500);
              hasJumpedRef.current = true;
            }
          }}
          renderError={(err) => {
            console.error(err);
            onLoadError?.(err);
            return <div className="p-4 text-destructive">Failed to load PDF</div>;
          }}
        />
      </Worker>
    </div>
  );
}
